// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-common-PageLoader-module__root--1vL2l","full-screen":"src-components-common-PageLoader-module__full-screen--1oTBb"};